import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSwipeable } from 'react-swipeable';
import { useFormik } from 'formik';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import RegularButton from '../../../../components/RegularButton';
import LinkButton from '../../../../components/LinkButton';
import Input from '../../../../components/Input';
import { personalPhoneNumberValidationSchema } from '../../../../common/validation/yup';
import IconButton from '../../../../components/IconButton';
import { ReactComponent as ArrowRight } from '../../../../assets/icons/arrow-right.svg';
import { ReactComponent as ArrowLeft } from '../../../../assets/icons/arrow-left.svg';
import styles from './styles.module.scss';

interface IPersonalPhoneProps {
  phoneNumber: string;
  onGoBack: IBindingAction;
  onSkip: IBindingAction;
  onAddPhoneNumber: IBindingCallback1<string>;
}

const PersonalPhone: FunctionComponent<IPersonalPhoneProps> = ({
  phoneNumber,
  onGoBack,
  onSkip,
  onAddPhoneNumber
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const { values, handleSubmit, setFieldValue, isValid, dirty } = useFormik({
    initialValues: { phoneNumber },
    onSubmit: val => onAddPhoneNumber(val.phoneNumber),
    validationSchema: personalPhoneNumberValidationSchema,
    validateOnBlur: true,
    validateOnMount: true
  });
  const swipeHandler = useSwipeable({
    onSwipedLeft: () => ((isValid && values.phoneNumber) ? handleSubmit() : onSkip()),
    onSwipedRight: onGoBack,
    trackMouse: false
  });

  return (
    <div {...swipeHandler} className="cf-container">
      <div className="cf-header-title mb-2">
        <FormattedMessage id="candidateForm.personal.header" defaultMessage="Personal info" />
      </div>
      <p className="cf-title mb-0">
        <FormattedMessage
          id="candidateForm.personal.title"
          defaultMessage="For security purposes, please provide your mobile phone number"
        />
      </p>
      <form onSubmit={handleSubmit} autoComplete="off" className="mb-5 w-100">
        <Input
          className={styles.phoneNumberInput}
          placeholder={{
            id: 'candidateForm.personal.placeholder',
            defaultMessage: 'Enter mobile phone number'
          }}
          type="phoneNumber"
          error={!isValid && dirty && !isFocused}
          success={isValid && Boolean(values.phoneNumber)}
          value={values.phoneNumber}
          onChange={value => setFieldValue('phoneNumber', value)}
          variant="underlined"
          size="lg"
          onBlur={() => setIsFocused(false)}
          onFocus={() => setIsFocused(true)}
        />
      </form>
      <div className="cf-footer-btns">
        <IconButton
          size="lg"
          icon={<ArrowLeft />}
          onClick={onGoBack}
        />
        <div className="d-flex align-items-center">
          <div className="mr-4">
            <LinkButton
              size="lg"
              textIntlId="Skip"
              onClick={onSkip}
              disabled
              enableAction
            />
          </div>
          <RegularButton
            disabled={!isValid || !values.phoneNumber}
            size="lg"
            textIntlId="candidateForm.next"
            defaultMessage="Next"
            icon={<ArrowRight />}
            iconPosition="right"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalPhone;
